import React, { useState, useEffect } from 'react';
import Flag from 'react-world-flags';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import { ChevronDown } from 'react-feather';
import { Images } from '../../assets';

const CountryCodeDropDown = ({
  Country,
  isOpen,
  toggle,
  selectedCountry,
  handleSelect,
}) => {
  return (
    <Dropdown
      isOpen={isOpen}
      toggle={toggle}
      className='country-code-drop-down-wrapper'
      id='country-code-drop-down-wrapper_id'
      // disabled={true}
    >
      <DropdownToggle caret className='selected-country'>
        {selectedCountry ? (
          <>
            <Flag code={selectedCountry.code} />
            <p>{selectedCountry?.dial_code}</p>
          </>
        ) : (
          'Select'
        )}
        <img src={Images.dropDownLogo} className='dropdown-icon' />
      </DropdownToggle>
      <DropdownMenu
        className={`country-code-list ${isOpen ? '' : 'hide'}`}
        caret
      >
        {Country.map((item) => (
          <DropdownItem onClick={() => handleSelect(item)}>
            <Flag code={item.code} />
            <p>{item?.dial_code}</p>
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default CountryCodeDropDown;
